import { Badge, Button, ButtonGroup, Table } from 'react-bootstrap'
import './AssistanceGrid.scss'
import { useTranslation } from 'react-i18next';
import { Spinner } from "react-bootstrap";
import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { ISelectOptions } from 'aw-combobox';
import { Assistance } from '../../../utils/models/Assistance';
import { getAssistanceTypesColor } from '../../../utils/const';

const AssistanceGrid = (props: {
    assistances: Assistance[];
    loading: boolean;
    typesOptions: ISelectOptions[];
    statesOptions: ISelectOptions[];
    machinesOptions: ISelectOptions[];
    userOptions: ISelectOptions[];
    onEditClick: (c: Assistance) => void;
    onDeleteClick: (c: Assistance) => void;
}) => {
    const { t } = useTranslation();
    const [assistances, setAssistances] = useState<Assistance[]>(props.assistances)

    useEffect(() => {
        let assistances = props.assistances
        setAssistances(assistances.sort((a, b) => a.id - b.id));
        // setAssistances(assistances.sort((a, b) => new Date(b.assistance_date).getTime() - new Date(a.assistance_date).getTime()));
    }, [props.assistances])

    const getUserName = (id: number | null) => props.userOptions.find(u => u.value === id)?.label ?? '';
    const getMachineName = (id: number | null) => props.machinesOptions.find(m => m.value === id)?.label ?? '';

    return (
        <>
            <div className={`p-2 rounded-1 editGridAssistance`} id='gridAssistanceContainer'>
                {props.loading ? <div className="text-center pt-5"><Spinner animation="border" variant="success" /></div> : (assistances.length > 0) ? <div className={`table-responsive editScrollAssistance`}>
                    <Table hover className='gridsStyle'>
                        <thead>
                            <tr>
                                <th>{t('Identifier')}</th>
                                <th>{t('Title')}</th>
                                <th>{t('Installation')}</th>
                                <th>{t('Machine')}</th>
                                <th>{t('User')}</th>
                                <th>{t('Type')}</th>
                                <th>{t('State')}</th>
                                <th>{t('Date')}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {assistances.map((a: Assistance, index: number) => (
                                <tr key={index} className={`tableLine`}>
                                    <td>{a.id}</td>
                                    <td>{a.title}</td>
                                    <td>{a.installation || ''}</td>
                                    <td>{getMachineName(a.machineId) || ''}</td>
                                    <td>{getUserName(a.userId) || ''}</td>
                                    <td><h6><span className="badge" style={{backgroundColor: getAssistanceTypesColor(a.type)}}>{props.typesOptions.find((t) => t.value === a.type)?.label}</span></h6></td>
                                    <td><h6><span className={`state-badge-${a.stateId}`}>{props.statesOptions.find((s) => s.value === a.stateId)?.label}</span></h6></td>
                                    <td>{format(new Date(a.assistance_date), "dd/MM/yyyy HH:mm")}</td>
                                    <td className="text-end">
                                        <ButtonGroup>
                                            <button onClick={() => props.onDeleteClick(a)} className='btn-Custom btn-IDRed me-3 buttonRadius'>
                                                <i className="bi bi-trash"></i>
                                            </button>
                                            <button onClick={() => props.onEditClick(a)} className='btn-Custom btn-IDGreen buttonRadius'>
                                                <i className="bi bi-pencil"></i>
                                            </button>
                                        </ButtonGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div> : <p className='text-center'>{t('NoAssistances')}</p>}
            </div>
        </>
    )
}

export default AssistanceGrid